import { ModelFactory } from './model.factory';

export const modelFactory = new ModelFactory();
